import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
	AppBar,
	Box,
	Button,
	Container,
	Drawer,
	IconButton,
	List,
	ListItemButton,
	ListItemText,
	Toolbar,
	Typography,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

const links = [
	{ to: '/', label: 'Home' },
	{ to: '/hue-colors', label: 'Hue Colors' },
	{ to: '/file-upload', label: 'File Upload' },
	{ to: '/wol', label: 'Wake on LAN' },
]

export const NavMenu = () => {
	const [open, setOpen] = useState(false)
	const { pathname } = useLocation()

	return (
		<AppBar position="static" color="default" elevation={1} sx={{ mb: 3 }}>
			<Container>
				<Toolbar disableGutters>
					<Typography
						variant="h6"
						component={Link}
						to="/"
						sx={{ flexGrow: 1, color: 'inherit', textDecoration: 'none' }}
					>
						DevTools
					</Typography>
					<Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 1 }}>
						{links.map((link) => (
							<Button
								key={link.to}
								component={Link}
								to={link.to}
								color="inherit"
								sx={{ fontWeight: pathname === link.to ? 'bold' : 'normal' }}
							>
								{link.label}
							</Button>
						))}
					</Box>
					<IconButton
						color="inherit"
						edge="end"
						aria-label="menu"
						onClick={() => setOpen(true)}
						sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
					>
						<MenuIcon />
					</IconButton>
				</Toolbar>
			</Container>
			<Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
				<List sx={{ minWidth: 200 }}>
					{links.map((link) => (
						<ListItemButton
							key={link.to}
							component={Link}
							to={link.to}
							selected={pathname === link.to}
							onClick={() => setOpen(false)}
						>
							<ListItemText primary={link.label} />
						</ListItemButton>
					))}
				</List>
			</Drawer>
		</AppBar>
	)
}
